module.exports = __webpack_public_path__ + "static/img/wdzt1-9.6fba3cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-9.png
// module id = 859
// module chunks = 0